import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { Regular, Medium, MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import Counter from './Counter'
import dataFund from './datafund.png'
import dataFund2x from './datafund@2x.png'
import Link from '~shared/Link'
import Spacer from '~shared/Spacer'
import Display from '~shared/Display'
import Clip from '~shared/Clip'
import urls from '~utils/urls'

const Container = styled.div`
    padding: 0 2rem 4.25rem 2rem;

    @media ${MqTablet} {
        padding: 0 0 9.875rem 0;
        max-width: 31rem;
        margin: 0 auto;
    }

    @media ${MqDesktop} {
        max-width: 46rem;
        margin: 0 auto;
    }
`

const UnstyledHeadline = forwardRef(function UnstyledHeadline({ children, ...props }, ref) {
    return (
        <Spacer head="64px,72px," tail="32px,,">
            <h1 {...props} ref={ref}>
                {children}
            </h1>
        </Spacer>
    )
})

export const Headline = styled(UnstyledHeadline)`
    font-weight: ${Regular};
    font-size: 28px;
    line-height: 40px;
    margin: 0;

    @media ${MqTablet} {
        font-size: 40px;
        line-height: 52px;
    }

    @media ${MqDesktop} {
        font-size: 48px;
        line-height: 56px;
    }
`

export const Paragraph = styled.p`
    font-size: 16px;
    line-height: 28px;
    margin: 0;

    & + & {
        margin-top: 28px;
    }

    b {
        font-weight: ${Medium};
    }

    @media ${MqTablet} {
        font-size: 18px;
        line-height: 30px;

        & + & {
            margin-top: 30px;
        }
    }
`

const UnstyledHero = (props) => (
    <Container {...props}>
        <Spacer head="36px,144px,142px" $appear>
            <Display mobile="block" tablet="none">
                <Clip width={148} height={152}>
                    <img src={dataFund} srcSet={`${dataFund2x} 2x`} alt="" />
                </Clip>
            </Display>
            <Display mobile="none" tablet="block">
                <Clip width={180} height={184} dx={0.13}>
                    <img src={dataFund} srcSet={`${dataFund2x} 2x`} alt="" />
                </Clip>
            </Display>
        </Spacer>
        <Headline $appear>
            The Streamr Data Fund
        </Headline>
        <Paragraph $appear>
            The Data Fund exists to support projects that further the vision of a decentralized data economy and welcomes all proposals.
            It is funded by a 10 million DATA allocation set aside from the initial project funds.
        </Paragraph>
        <Paragraph $appear>
            <b>Quick Response grants</b>
            {' '}
            offer up to $5000 USD and they are available for building integrations,
            demo apps, adding quality free data sources to the Streamr Network, research, community initiatives and other smaller projects.
        </Paragraph>
        <Paragraph $appear>
            <b>Project grants</b>
            {' '}
            offer up to $50,000 USD, and are available to fund Data Union applications, data tools and other large
            scale projects.
        </Paragraph>
        <Spacer head="3.5rem,," tail>
            <Counter $appear />
        </Spacer>
        <Paragraph $appear>
            To apply, send us your submission via the form below. We will get in touch and discuss your proposal with you.
            If you are applying for a Project grant, a team member will be able to offer help and advice on your proposal
            before the final funding decision.
        </Paragraph>
        <Paragraph $appear>
            You&apos;re also welcome to drop into our
            {' '}
            <Link href={urls.community.discord} newTab>Discord</Link>
            {' '}
            to ask any questions not covered by the FAQ on this page.
        </Paragraph>
    </Container>
)

const Hero = styled(UnstyledHero)`
    color: #0C009A;

    ${Clip} {
        margin: 0 auto;
    }

    @media ${MqTablet} {
        ${Clip} {
            margin: 0;
        }
    }
`

export default Hero
